import { motion } from "framer-motion";

export default function Loading() {
    return (
        <div className="fixed inset-0 z-[9999] w-full min-h-screen bg-[#08090d] flex items-center justify-center overflow-hidden">
            <div className="flex flex-col items-center gap-8 z-10 px-4">
                {/* Dual Pulsing Neon Ring around Logo (Zero Blur, Zero Shadow Animation) */}
                <div className="relative flex items-center justify-center">
                    {/* Outer Rotating Ring (Linear) */}
                    <motion.div
                        animate={{
                            rotate: 360,
                        }}
                        transition={{
                            duration: 5,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                        className="w-[130px] h-[130px] rounded-full border-2 border-dashed border-pink/40 absolute"
                    />

                    {/* Inner Reverse Ring (Linear) */}
                    <motion.div
                        animate={{
                            rotate: -360,
                        }}
                        transition={{
                            duration: 6,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                        className="w-[110px] h-[110px] rounded-full border-2 border-transparent border-t-biruMuda border-b-pink absolute"
                    />

                    {/* Centered Logo Badge */}
                    <div className="w-[85px] h-[85px] rounded-full bg-white flex items-center justify-center p-3 z-20">
                        <img
                            src="/logo-crop.png"
                            alt="I-FIT"
                            className="w-full h-full object-contain"
                        />
                    </div>
                </div>

                {/* Typography */}
                <div className="flex flex-col items-center gap-2 text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: "linear" }}
                    >
                        <h2 className="text-2xl md:text-3xl font-black tracking-widest bg-gradient-to-r from-white via-pink to-biruMuda bg-clip-text text-transparent">
                            I-FIT INDONESIA
                        </h2>
                    </motion.div>

                    <motion.div
                        animate={{
                            opacity: [0.4, 0.9, 0.4],
                        }}
                        transition={{
                            duration: 1.6,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    >
                        <p className="text-xs sm:text-sm text-gray-400 tracking-widest uppercase font-semibold">
                            Postural Specialist & Fitness
                        </p>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}
